import { OPEN_COMPRESSOR_FORM, OPEN_CONVERTOR_FORM } from "../constants/actionTypes";

const convertorCompressorReducer = (state= { inputType: null, outputType: null, acceptKey: null } , action) => {
    switch(action.type) {
        case OPEN_COMPRESSOR_FORM:
        case OPEN_CONVERTOR_FORM:
            return { ...state, inputType: action.payload.inputType, outputType: action.payload.outputType, acceptKey: action.payload.acceptKey };
        default:
        return state;
    }
  }


export default convertorCompressorReducer;